import React from 'react';

const Tracks = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <main className="content">
          <div className="card-box">
            <h1 style={{ color: "#185668" }}>
              Call for Papers
            </h1>
            <p>
              DICON 2027 invites original research papers in the areas of intelligent computing and emerging technologies.
              The conference provides a global platform for researchers, academicians, industry professionals, and students
              to share pioneering ideas that shape the technological landscape of tomorrow.
            </p>

            <h3>Conference Theme</h3>
            <p>
              Empowering the Future through Intelligent and Sustainable computing
            </p>

            <h3>Conference Tracks</h3>

            <h4>Track 1: Artificial Intelligence and Computational Intelligence</h4>
            <ul className="track-list">
              <li>Machine Learning</li>
              <li>Deep Learning</li>
              <li>Generative Artificial Intelligence</li>
              <li>Natural Language Processing (NLP)</li>
              <li>Computer Vision</li>
              <li>Reinforcement Learning</li>
              <li>Explainable Artificial Intelligence (XAI)</li>
              <li>Human-Centered Artificial Intelligence</li>
              <li>Federated Learning</li>
              <li>Robotics and Intelligent Systems</li>
              <li>Evolutionary Computing</li>
              <li>Bio-inspired Computing</li>
            </ul>

            <h4>Track 2: IoT and Sensor Networks</h4>
            <ul className="track-list">
              <li>Wireless Sensor Networks</li>
              <li>Internet of Things (IoT) Architectures and Protocols</li>
              <li>Edge–Cloud Integration for IoT</li>
              <li>Energy-Efficient IoT Systems</li>
              <li>Industrial Internet of Things (IIoT)</li>
              <li>Smart Cities and Smart Infrastructure</li>
              <li>IoT Security and Privacy</li>
              <li>Sensor Fusion Techniques</li>
              <li>Blockchain-Enabled IoT</li>
              <li>Smart Agriculture and Precision Farming</li>
            </ul>

            <h4>Track 3: Cybersecurity and Privacy in Intelligent Systems</h4>
            <ul className="track-list">
              <li>Secure System Architectures</li>
              <li>Cryptography and Cryptographic Protocols</li>
              <li>Privacy-Preserving Artificial Intelligence</li>
              <li>Intrusion Detection and Prevention Systems</li>
              <li>Cyber Forensics and Incident Response</li>
              <li>Blockchain and Distributed Ledger Security</li>
              <li>Identity and Access Management</li>
              <li>Cloud and Virtualization Security</li>
              <li>Cyber Resilience and Risk Management</li>
              <li>Ethical, Legal, and Regulatory Aspects of Cybersecurity</li>
            </ul>

            <h4>Track 4: Electronics and Embedded Systems for Smart Technologies</h4>
            <ul className="track-list">
              <li>Low-Power and Energy-Efficient Electronics</li>
              <li>VLSI and System-on-Chip (SoC) Design</li>
              <li>Embedded Systems Design</li>
              <li>Hardware–Software Co-Design</li>
              <li>FPGA-Based Systems</li>
              <li>Micro-Electro-Mechanical Systems (MEMS)</li>
              <li>Power Electronics and Drives</li>
              <li>Wearable Electronics and Biomedical Devices</li>
              <li>Reliable and Fault-Tolerant Hardware Design</li>
            </ul>

            <h4>Track 5: Sustainable Computing and Emerging Paradigms</h4>
            <ul className="track-list">
              <li>Green and Energy-Efficient Computing</li>
              <li>Sustainable Communication Networks</li>
              <li>Energy-Efficient Data Centers</li>
              <li>Carbon-Aware Cloud Computing</li>
              <li>Quantum Computing</li>
              <li>Neuromorphic Computing</li>
              <li>Sustainable Artificial Intelligence</li>
              <li>Edge Computing for Sustainability</li>
              <li>Computing Lifecycle Assessment and Circular Economy</li>
            </ul>

            <h4>Track 6: Data Science, Cloud, and Edge Computing</h4>
            <ul className="track-list">
              <li>Big Data Analytics</li>
              <li>Cloud-Native Systems and Microservices</li>
              <li>Edge and Fog Computing</li>
              <li>Data Mining and Knowledge Discovery</li>
              <li>Scalable Machine Learning Systems</li>
              <li>Real-Time and Stream Processing</li>
              <li>Distributed Storage Systems</li>
              <li>AI-Driven Cloud Resource Optimization</li>
              <li>Hybrid and Multi-Cloud Architectures</li>
            </ul>

            <h3>Submission Guidelines</h3>
            <p>
              Paper Submission: All manuscripts must be submitted electronically through the Microsoft CMT submission system. Authors can submit their papers using the following link: <a href="https://cmt3.research.microsoft.com/DICON2027" target="_blank" rel="noopener noreferrer">CMT Submission Portal</a>.
            </p>
            <p>
              For complete submission instructions, templates, and author preparation guidelines, please visit the Author Submission page.
            </p>
            <ul className="track-list">
              <li>Papers should be original work and not submitted elsewhere</li>
              <li>Manuscripts should follow IEEE formatting guidelines</li>
              <li>Papers will undergo peer review process</li>
              <li>Accepted papers will be published in IEEE Xplore</li>
              <li>At least one author must register for the conference</li>
              <li>All papers must be presented at the conference</li>
            </ul>

            <h3>Important Dates</h3>
            <ul className="track-list">
              <li>Paper Submission Deadline: November 30, 2026 (IST)</li>
              <li>Notification of Acceptance: January 15, 2027 (IST)</li>
              <li>Camera-ready Paper Submission: February 10, 2027 (IST)</li>
              <li>Conference Dates: April 23-24, 2027 (IST)</li>
            </ul>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Tracks;
